import React, { useState } from "react";

import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import {
  AiFillFileExcel,
  AiOutlineClose,
  AiOutlineFile,
  AiOutlineFileJpg,
  AiOutlineFilePdf,
  AiOutlineFileWord,
} from "react-icons/ai";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { fileExtention } from "app/_helpers/helper";
import EvidenceVideo from "app/_pages/_healthSafetyEnvironment/IncidentManagement/EvidenceVideo";
import { FcVideoFile } from "react-icons/fc";

const docType = (name, size = 50, color = "", classNam = "") => {
  let extenstion = fileExtention(name);
  extenstion = extenstion ? extenstion.toLowerCase() : extenstion;

  if (extenstion) {
    if (extenstion === "jpg" || extenstion == "jpeg" || extenstion == "jpeg") {
      return <AiOutlineFileJpg size={size} color={color} className={classNam} />;
    } else if (extenstion === "pdf") {
      return <AiOutlineFilePdf size={size} color={color} className={classNam} />;
    } else if (extenstion === "doc" || extenstion == "docx") {
      return <AiOutlineFileWord size={size} color={color} className={classNam} />;
    } else if (extenstion === "xls" || extenstion == "xlsx") {
      return <AiFillFileExcel size={size} color={color} className={classNam} />;
    } else {
      return <AiOutlineFile size={size} color={color} className={classNam} />;
    }
  }
};

const CompletionProofPreview = ({ data, isShow, closeCompletionProof }) => {
  const [fileType, setFileType] = useState("");
  const [file, setFile] = useState("");

  const handlePrview = (type, file) => {
    setFile(file);
    setFileType(type);
  };

  const closeModal = () => {
    setFile("");
    setFileType("");
    closeCompletionProof();
  };
  return (
    <>
      <Modal show={isShow} onHide={() => closeModal()} size="xl">
        <div className="card" style={{ overflow: "visible" }}>
          <div className="card-body">
            <Row className="mb-3">
              <Col lg={!file ? 12 : 6}>
                <div className="ehsFormWrapper">
                  {data?.map((obj, idx) => {
                    if (!obj?.completionProof) return null;
                    const { userData, completionProof } = obj;
                    let extenstion = fileExtention(completionProof?.document_name);
                    extenstion = extenstion ? extenstion.toLowerCase() : extenstion;
                    return (
                      <div key={idx} className="completionSec">
                        <Row className="lft_content">
                          <Col lg={4}>
                            <div className="form-group viewbox">
                              <h5 className="w-500">Task Owner</h5>
                              <p>{userData?.firstName + " " + userData?.lastName}</p>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="form-group viewbox">
                              <h5 className="w-500">Alias Name</h5>
                              <p>{completionProof?.alias}</p>
                            </div>
                          </Col>
                          <Col lg={4}>
                            {extenstion === "mp4" ? (
                              <span
                                onClick={() =>
                                  handlePrview("video", completionProof?.document_name)
                                }
                              >
                                <FcVideoFile size={25} />
                              </span>
                            ) : extenstion === "pdf" ? (
                              <div>
                                <span
                                  onClick={() =>
                                    window.open(
                                      `${URL_CONFIG.IMG_URL}${completionProof?.document_name}`,
                                      "_blank"
                                    )
                                  }
                                >
                                  {docType(completionProof?.document_name)}
                                </span>
                              </div>
                            ) : extenstion === "xls" || extenstion === "xlsx" ? (
                              <div>
                                <span
                                  onClick={() =>
                                    window.open(
                                      `${URL_CONFIG.IMG_URL}${completionProof?.document_name}`,
                                      "_blank"
                                    )
                                  }
                                >
                                  {docType(completionProof?.document_name)}
                                </span>
                              </div>
                            ) : (
                              <img
                                onClick={() =>
                                  handlePrview("image", completionProof?.document_name)
                                }
                                className="evidenceImg"
                                src={`${URL_CONFIG.IMG_URL}${completionProof?.document_name}`}
                                alt={""}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col lg={6}>
                <div className="popupImgVideo position-relative">
                  {file && (
                    <AiOutlineClose
                      className="previewCloseIcon"
                      onClick={() => {
                        setFile("");
                        setFileType("");
                      }}
                    />
                  )}
                  {fileType === "video" ? (
                    <EvidenceVideo
                      src={`${URL_CONFIG.IMG_URL}${file}`}
                      width={"500px"}
                      hideClass
                    />
                  ) : (
                    <img
                      className=""
                      src={`${URL_CONFIG.IMG_URL}${file}`}
                      alt={""}
                      width={"500px"}
                    />
                  )}
                </div>
              </Col>
            </Row>
            <div className="mt-2 text-center">
              <Button onClick={() => closeModal()} className="btn btn-secondary mr-2">
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CompletionProofPreview;
